async function addToCart(productId, quantity, btn) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: productId,
              quantity: quantity,
            }),
        });

        if (!response.ok) {
          throw new Error('Error adding to cart');
        }

        const data = await response.json();
        // Display a success message
        // console.log('Add to Cart Response:', data);
        updatecart('/', btn);

        //Removed active classes from popup and button
        let featureWrapper = btn.closest('.multi-variant-popup-wrapper');
        if (featureWrapper) {
          featureWrapper.classList.remove('open');
          setTimeout(() => {
            featureWrapper.classList.remove('active');
          }, 700);
          document.querySelector("html.js").style.removeProperty("overflow");
          btn.classList.remove('btn-loading');
        }
    } catch (error) {
      // Display error message
      btn.classList.remove("loading");
      // console.error('Add to Cart Error:', error);
    }
}
function updatecart(url, btn) {
  fetch(url).then(function (response) {
    // The API call was successful!
    return response.text();
  }).then(function (html) {
    // Convert the HTML string into a document object
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    btn.classList.remove("loading");
    document.querySelector(".thb-secondary-cart").innerHTML = doc.querySelector(".thb-secondary-cart").innerHTML;
    document.querySelector('#Cart-Drawer').innerHTML = doc.querySelector("#Cart-Drawer").innerHTML;
    document.querySelector("#cart-drawer-toggle").click();
  }).catch(function (err) {
    // There was an error
    // console.warn('Something went wrong.', err);
  }).finally(() => {
    // Remove loading class from button
    window.initProductRxcommendationsSlider();
  });
}
const changeEvent = (data) => {
      let parent = data;
      console.log('AKJ',data);
      if (!parent) {
        return;
      }
      if (document.querySelector("variant-radios input", parent)) {
        document.querySelectorAll("variant-radios input", parent).forEach(item => {
          item.addEventListener('change', (e) => {
            document.querySelectorAll('variant-radios input',parent).forEach(option => {
              option.closest('.option-list').classList.remove('selected');
            });
            document.querySelectorAll('variant-radios input:checked', parent).forEach(option => {
              option.closest('.option-list').classList.add('selected');
            });
            if(parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset") && parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset").length > 1) {
              //variantChange(parent);
            } else {
              let addToCartBtn = parent.querySelector('.variant-quick-add-cart-js');
              let isVariantAvailable = false;
              if(item.getAttribute("is-available") == "true") {
                isVariantAvailable = true;
              }
              let price = item.getAttribute('data-price');
              addToCartBtn.setAttribute('data-price', price);
              let vId = item.getAttribute('data-vid');
              addToCartBtn.setAttribute('data-vid', vId);
              if(isVariantAvailable) {
                addToCartBtn.removeAttribute('disabled');
                addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "ADD TO CART";
              }
              else {
                addToCartBtn.setAttribute('disabled', '');
                addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "SOLD OUT";
              }
            }
          })
        })
      }
    };
function updateURL(url, key, value) {
    const urlObj = new URL(url);
    if (urlObj.searchParams.has(key)) {
        urlObj.searchParams.delete(key);
    } else {
        urlObj.searchParams.append(key, value);
    }

    var newURL = urlObj.toString().replace(/%5B%5D/g, '[]');

    return newURL;
}
// const colorMap = new Map([
//   ["Mint Green", ["#3EB489", !1]],
//   ["Sky Blue", ["#B2D5E9", !1]],
//   ["HIGH-GRAD-GRAY", ["#AEB2B5", !1]],
//   ["Dark Green", ["#4BA28A", !1]],
//   ["CHERRY BLOSSOM PINK", ["#DCB1AA", !1]],
//   ["LIGHT BROWN", ["#805630", !1]],
//   ["COFFEE", ["#F9F6E9", !1]],   // first one
//   ["DARK BLUE", ["#3E536C", !1]],
//   ["DARK GREY", ["#8B8282", !1]],
//   ["CREAM", ["#C5B3A0", !1]],
//   ["SILVER GRAY", ["#5B5B57", !1]],
//   ["ELEGANT GRAY", ["#717878", !1]],
//   ["MOCHA", ["#C3B7AB", !1]],
//   ["AMBER", ["#AD7E4B", !1]],
//   ["PINE GREEN", ["#8A9761", !1]],
//   ["Black Flowers", ["#090909", !1]],
//   ["Orange Flowers", ["#A44D23", !1]],
//   ["Green Flowers", ["#48623F", !1]],
//   ["White Flowers", ["#F8F8F8", !1]],
//   ["CLARET", ["#743246", !1]],
//   ["LIGHT GREY", ["#908584", !1]],
//   ["OFF-WHITE", ["#D1BBA5", !1]],
//   ["Grey Transparent Lid", ["#594323", !1]],
//   ["Cream White Lid", ["#FCF5E9", !1]],
//   ["GOLDEN", ["#E6CD57", !1]],
//   ["BIEGE", ["#B99C89", !1]],
//   ["COFFEE", ["#744B40", !1]],  // second one, but ⚠️ duplicate name
// ]);

// const colorMap = new Map([
//   ["Grey", ["#b0b3bc", !1]],
//   ["Carbon steel", ["#41423f", !1]],
//   ["White", ["#FFFFFF", !1]],
//   ["Black", ["#0f0f00", !1]],
//   ["Bamboo", ["#D2B48C", !1]],
//   ["Beige", ["#e2dac6", !1]],
//   ["Transparent White", ["#FFFFFF00", !1]],
//   ["Stainless Steel", ["#CFD4D9", !1]],
//   ["Orange", ["#fe8959", !1]],
//   ["Green", ["#454842", !1]],
//   ["Transparent Black", ["#000000F", !1]],
//   ["Lime Green", ["#d3f5e0", !1]],
//   ["Brown", ["#874232", !1]],
//   ["Red", ["#bc2021", !1]],
//   ["Blue", ["#48a1f6", !1]],
//   ["Pink", ["#e8c8bc", !1]],
//   ["Yellow", ["#eed557", !1]],
//   ["Dark Pink", ["#e387b7", !1]],
//   ["Caramel", ["#dbd8d0", !1]],
//   ["Coffee", ["#805323", !1]],
//   ["Dark Grey", ["#73717d", !1]],
//   ["Pastel Green", ["#c7c6c1", !1]],
//   ["Dark blue", ["#46617a", !1]],
//   ["Pastel Yellow", ["#e5d3b2", !1]],
//   ["Pastel Purple", ["#a598a6", !1]],
//   ["Maifan Black", ["#3e3e3e", !1]],
//   ["Maifan White", ["#d9cbb7", !1]],
//   ["Gold", ["#D4AF37", !1]],
//   ["Aluminium", ["#888B8D", !1]],
// ]);

const colorMap = new Map([
  // === Your previous entries ===
  ["Grey", ["#b0b3bc", !1]],
  ["Carbon steel", ["#41423f", !1]],
  ["White", ["#FFFFFF", !1]],
  ["Black", ["#0f0f00", !1]],
  ["Bamboo", ["#D2B48C", !1]],
  ["Beige", ["#e2dac6", !1]],
  ["Transparent White", ["#FFFFFF00", !1]],
  ["Stainless Steel", ["#CFD4D9", !1]],
  ["Orange", ["#fe8959", !1]],
  ["Green", ["#454842", !1]],
  ["Transparent Black", ["#000000F0", !1]], // fixed invalid hex
  ["Lime Green", ["#d3f5e0", !1]],
  ["Brown", ["#874232", !1]],
  ["Red", ["#bc2021", !1]],
  ["Blue", ["#48a1f6", !1]],
  ["Pink", ["#e8c8bc", !1]],
  ["Yellow", ["#eed557", !1]],
  ["Dark Pink", ["#e387b7", !1]],
  ["Caramel", ["#dbd8d0", !1]],
  ["Coffee", ["#805323", !1]],
  ["Dark Grey", ["#73717d", !1]],
  ["Pastel Green", ["#c7c6c1", !1]],
  ["Dark blue", ["#46617a", !1]],
  ["Pastel Yellow", ["#e5d3b2", !1]],
  ["Pastel Purple", ["#a598a6", !1]],
  ["Maifan Black", ["#3e3e3e", !1]],
  ["Maifan White", ["#d9cbb7", !1]],
  ["Gold", ["#D4AF37", !1]],
  ["Aluminium", ["#888B8D", !1]],

  // === New Additions ===
  ["Gray", ["#808080", !1]],          // standard gray
  ["BROWN", ["#8B4513", !1]],        // saddle brown
  ["BEIGE", ["#F5F5DC", !1]],        // standard beige
  ["RED", ["#FF0000", !1]],          // pure red
  ["YELLOW", ["#FFFF00", !1]],       // pure yellow
  ["Light Grey", ["#D3D3D3", !1]],   // light gray
  ["Transparent", ["#00000000", !1]],// fully transparent
  ["COFFE", ["#6F4E37", !1]],        // corrected coffee
  ["Cream", ["#FFFDD0", !1]],        // cream
  ["GOLDEN", ["#FFD700", !1]],       // golden yellow
  ["GREY", ["#A9A9A9", !1]],         // dark grey variant
  ["BIEGE", ["#F5F5DC", !1]],        // same as beige (duplicate spelling)
  ["Cream White", ["#FAF9F6", !1]],  // off-white cream
  ["DAISY", ["#FFFFE0", !1]],        // light daisy yellow
  ["DARK BLUE", ["#00008B", !1]],    // dark blue standard
  ["Dark green", ["#006400", !1]],   // dark green
  ["Fog blue", ["#A7C7E7", !1]],     // soft foggy blue
  ["Khaki", ["#F0E68C", !1]],        // khaki
  ["LIGHT BROWN", ["#A52A2A", !1]],  // light brown
  ["LIGHT GREEN", ["#90EE90", !1]],  // light green
  ["LOTUS PINK", ["#F4A6B9", !1]],   // lotus pink
  ["MUSTRAD", ["#FFDB58", !1]],      // mustard yellow
  ["Navy Blue", ["#000080", !1]],    // navy blue
  ["PEACOCK BLUE", ["#1A4D7A", !1]], // peacock blue
  ["PINE GREEN", ["#01796F", !1]],   // pine green
  ["PURPLE", ["#800080", !1]],       // purple
  ["SILVER", ["#C0C0C0", !1]],       // silver
  ["Transparent Grey", ["#80808080", !1]], // semi-transparent grey
  ["Sky Blue", ["#87CEEB", !1]],  // standard sky blue
  ["CARAMEL", ["#dbd8d0", !1]],   // from your first provided list
  ["Coffee", ["#805323", !1]],    // from your first provided list
  ["COFFE", ["#6F4E37", !1]],     // typo variant from new list
  ["COFFEE", ["#744B40", !1]],    // duplicate name in your earlier map
  ["PEACOCK  BLUE", ["#1A4D7A", !1]],  // peacock blue

]);

function closeFilterForMobile() {
  const filterBg = document.querySelector(".wizzy-filters-bg");
  if(filterBg) filterBg.click();
}

function updateBodyClassForAppliedFilters() {
  const container = document.querySelector('.wizzy-selected-filters');
  const hasItems = container.querySelectorAll('li').length > 0;

  if (hasItems) {
    document.getElementsByTagName('body')[0].classList.add('has-selected-filters');
  } else {
    document.getElementsByTagName('body')[0].classList.remove('has-selected-filters');
  }
}

function findHaxCode(key) {
  return colorMap.has(key) ? colorMap.get(key) : [key, !1];
}


function handleButtonClickForInstock() {
    const currentURL = window.location.href;
    const paramKey = 'inStock[]';
    const paramValue = 'true';

    const updatedURL = updateURL(currentURL, paramKey, paramValue);
    window.executeWizzyFiltersFromURL(updatedURL);
}

window.addEventListener("load", function() {
  const searchButton = document.querySelector(".thb-secondary-area-item.thb-quick-search");
  if (searchButton) {
    searchButton.style.pointerEvents = "auto";
    searchButton.addEventListener("click",function() {
      setTimeout(() => {
        const searchBar = document.querySelector("#side-panel-search-input");
        if(searchBar) searchBar.click();
      }, 500);
      
    })
  }
  

});

document.body.addEventListener("click", function (event) {
  if (event.target.matches("#shopify-section-template--24674420949276__template-header .search-field")) {
    console.log("Hi");
    const searchButton = document.querySelector(".thb-secondary-area-item.thb-quick-search");
    if (searchButton) {
      searchButton.click();
    }
  }
});




const fetchProductDetails = (productUrl, button, event) => {
       
  fetch(productUrl)
  .then((response) => response.text())
  .then((responseText) => {
    
    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const sectionWrapper = button.closest('.shopify-section');
    
    if (sectionWrapper) {
      
      const popupWrapper = sectionWrapper.querySelector('.multi-variant-popup-wrapper');
      const productDetails = responseHTML.querySelector('.multi-variant-popup-content');

      if (popupWrapper && productDetails) {
        const popupContent = popupWrapper.querySelector('.multi-variant-popup-content');
        if (popupContent) {
          popupContent.innerHTML = productDetails.innerHTML;

          
          document.querySelector("html.js").style.overflow = "hidden";
          popupWrapper.classList.add('active');
          
          if(productDetails.querySelectorAll('variant-radios fieldset').length > 1 || productDetails.querySelectorAll(".options-wrapper .option-list").length > 4) {
            popupWrapper.querySelector(".multi-variant-popup-inner").classList.add("fix-height-popup");
          } else {
            popupWrapper.querySelector(".multi-variant-popup-inner").classList.remove("fix-height-popup");
          }

          setTimeout(() => {
            popupWrapper.classList.add('open');
          }, 200);
          
          changeEvent(popupWrapper);
          button.classList.remove('loading');
        }
      }
    }
  })
  .catch((error) => {
    // console.error('Error fetching product details:', error);
  });
};


window.onWizzyScriptLoaded = function() {

     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
        // console.log("Wizzy init...");
        window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
           mobile: 3000,
        };
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = !0;
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body #main-content"];
        data.filters.configs.keepOpenedInMobileAfterApply = true;    
        try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
            {
              from: 0,
              to: 500,
            },
            {
              from: 501,
              to: 1000,
            },
            {
              from: 1001,
              to: 2000,
            },
            {
              from: 2001,
              to: 3000,
            },
            {
              from: 3001,
              to: 5000,
            },
          ];
          }
          return obj;
        });
      } catch (error) {}
      data.search.configs.general.minQueryLength = 2;
        return data;
     });
     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
        // console.log("Wizzy init...");
        window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
           mobile: 3000,
        };
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = !0
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body #main-content"];
        data.filters.configs.keepOpenedInMobileAfterApply = true;    
        try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
            {
              from: 0,
              to: 500,
            },
            {
              from: 501,
              to: 1000,
            },
            {
              from: 1001,
              to: 2000,
            },
            {
              from: 2001,
              to: 3000,
            },
            {
              from: 3001,
              to: 5000,
            },
          ];
          }
          return obj;
        });
      } catch (error) {}
      data.search.configs.general.minQueryLength = 2;
        return data;
     });

     window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (products) {
    let productIds = [];

    // First loop: set attributes and collect product IDs
    products.forEach(product => {
      product.attributes.forEach(attribute => {
        if (attribute.id === "product_handle") {
          product.handle = attribute.values[0].value[0];
        } else if (attribute.id === "product_custom_call_out_badge_text_color_custom") {
          product.badgeTextColor = attribute.values[0].value[0];
        } else if (attribute.id === "product_custom_call_out_badge_background_color_custom") {
          product.badgeBackgroundColor = attribute.values[0].value[0];
        } else if (attribute.id === "product_custom_call_out_badge_custom") {
          product.hasCustomBadge = true;
          product.badgeValue = attribute.values[0].value[0];
        } else if (attribute.id === "product_variant_prices") {
          if(attribute.values.length > 1) {
            product.hasVariant = true;
          }
        } else if(attribute.id === "product_badge_judgeme") {
          let divElement = document.createElement("div");
              divElement.innerHTML = attribute.values[0].value[0];
              // console.log(divElement);
              product.isOnCategory = window.wizzyConfig.common.isOnCategoryPage;
              var jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
              var numberOfReviews = jdgmPrevBadge.getAttribute(
                "data-number-of-reviews"
              );
              var review = jdgmPrevBadge.getAttribute("data-average-rating");
              if (numberOfReviews > 0) {
                product.numberOfReviews = numberOfReviews;
                product.reviewAvailable = true;
              } else {
                product.reviewAvailable = false;
              }
              product.reviewData = attribute.values[0].value[0];
              product.avgRatings = parseFloat(parseFloat(review).toFixed(1));

              product.reviewData = function () {
                return function (text, render) {
                  return render(attribute.values[0].value[0]);
                };
              };
        }
      });

      productIds.push(product.id);
    });
    // console.log("productIds : ",productIds);
    // Create comma-separated product IDs
    let productIdsString = productIds.join(",");
    window.productIdsString = productIdsString;
    // console.log("AFTER : ",products);  
    return products;
  }
);
window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (data) {
    console.log("BEFORE_FILTERS_EXECUTED ==>",data.filters);
    if(data.filters.sort && data.filters.sort[0].field == "relevance") {
      data.filters.sort.push({"field":"product_variant_position:float","order": "asc", "isForParent":"false", "isForVariation": "true"});
    }
    // if (data.filters) {
    //   data.filters.getAllVariants = "true";
    //   data.filters.variantsGroupBy = "groupId";
    // }
    
    return data;
  }
);


     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
        if(data.sort && data.sort[0].field == "relevance") {
          data.sort.push({"field":"product_variant_position:float","order": "asc", "isForParent":"false", "isForVariation": "true"})
        }
        const closeButton = document.querySelector("#Search-Drawer .side-panel-close");
        if(closeButton) closeButton.click();

        const collectionHeader = document.querySelector("#shopify-section-template--24721340694812__template-header");
        if(collectionHeader) collectionHeader.style.display = "none";

        const collectionProduct = document.querySelector("#shopify-section-template--24721340694812__product-grid");
        if(collectionProduct) collectionProduct.style.display = "none";

        const collectionDes = document.querySelector("#shopify-section-template--24721340694812__rich_text_rBN69x");
        if(collectionDes) collectionDes.style.display = "none";

        const collectionBanner = document.querySelector("#shopify-section-template--24721340629276__slideshow_6jrt3m");
        if(collectionBanner) collectionBanner.style.display = "none";

        const collectionDhanterasBanner = document.querySelector("#shopify-section-template--24721340629276__slideshow_XyzwHx");
        if(collectionDhanterasBanner) collectionDhanterasBanner.style.display = "none";
        const facetDrawer = document.querySelector(".side-panel.facet-drawer");

        if (facetDrawer) {
          // find closest parent with class shopify-section
          const parentSection = facetDrawer.closest(".shopify-section");

          if (parentSection) {
            parentSection.style.display = "none";
          }
        }

        const templateHeader = document.querySelector(".template-header");

        if (templateHeader) {
          // find closest parent with class shopify-section
          const parentSection = templateHeader.closest(".shopify-section");

          if (parentSection) {
            parentSection.style.display = "none";
          }
        }

        document.documentElement.classList.remove("open-cc");
        return data;
     },1);
     window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (data) {
        console.log("BEFORE_AUTOCOMPLETE_EXECUTED ==>",data);
        if(data.sort && data.sort[0].field == "relevance") {
          data.sort.push({"field":"product_variant_position:float","order": "asc", "isForParent":"false", "isForVariation": "true"});
        }        
        return data;
      },2
    );

     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
        // console.log("BEFORE_AUTOCOMPLETE_RENDER : ",data);
        // Stop words to exclude
        // const stopWords = ["with", "for", "and"];

        // // Normalize function
        // function normalize(str) {
        //   let val = str.toLowerCase().trim();
        //   // remove ending 's' (basic plural handling)
        //   if (val.endsWith("s")) {
        //     val = val.slice(0, -1);
        //   }
        //   return val;
        // }

        // // Collect normalized category values
        // const categoryValues = new Set(
        //   data?.payload?.categories?.map(cat => normalize(cat.value))
        // );

        // // Filter "others"
        // data.payload.others = data?.payload?.others?.filter(item => {
        //   const val = item.value.toLowerCase().trim();
        //   const normVal = normalize(val);

        //   // Rule 1: remove if duplicate of category (even singular/plural variation)
        //   if (categoryValues.has(normVal)) {
        //     return false;
        //   }

        //   // Rule 2: remove if ends with stop words
        //   if (stopWords.some(sw => val.endsWith(" " + sw))) {
        //     return false;
        //   }

        //   // Rule 3: remove if only single word
        //   // if (val.split(/\s+/).length === 1) {
        //   //   return false;
        //   // }

        //   return true;
        // });


      
        return data;
     });

     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(data) {

        // console.log("BEFORE_RENDER_RESULTS : ",data);
        if (data.api === "search" || data.api === "filter") {
          var facets = data.response.payload.facets;
          // console.log(facets);
          if(facets)
          {
            // console.log("inside facets condition");
            facets.forEach((facet) => {
              if(facet.key === "colors")
              {
                // console.log("inside colors");
                facet.data.forEach((item) => {
                  // console.log("inside loop");
                  // console.log(item.key);
                  let color = findHaxCode(item.key) || ["#e5e5e5", !1];
                  // console.log(color);
                  // console.log("inside loop 1");
                  (item.isSwatch = !0),
                    (item.isURLSwatch = color[1]),
                    (item.isVisualSwatch = !0),
                    (item.swatchValue = color[0]),
                    (item.data = {
                      value: item.key,
                      swatch: {
                        type: "visual",
                        value: color[0],
                      },
                    });
                });
              }
              if(facet.key === "sellingPrice") {
                facet.data = facet.data.filter(bucket => bucket.count > 0);
              }
            });
          }
          // console.log(payload);
        }
        if(data.api === "search" || data.api === "filter") {
          const unwanted = ["testing", "or" , "duplicate" , "upsell"]; // keep unwanted words in lowercase
          data?.response?.payload?.facets?.forEach((facet) => {
            if(facet.key === "product_product_type") {
              facet.data = facet.data.filter(item => !unwanted.includes(item.label.toLowerCase()));
            }
          })
        }
        
        return data;
     });

     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {
      var inStockBtn = document.querySelector('#wizzy-search-filters-inStock-input');

      if (inStockBtn) {
        // inStockBtn.addEventListener('click', handleButtonClickForInstock);
        inStockBtn.addEventListener('click', handleButtonClickForInstock);
      }
      document.querySelectorAll(".product-card--add-to-cart-button-simple").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Prevent double clicks
        if (btn.classList.contains('loading')) return;

        const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

        btn.classList.add('loading');

        if (btn.classList.contains('disabled')) return;

        if (isPopupTrigger) {
          const productUrl = btn.dataset.vid;
          if (productUrl) {
            const url = `/products/${productUrl}?section_id=quick-add-product`;
            fetchProductDetails(url, btn, e);
          }
        } else {
          const ID = btn.getAttribute("data-product-id");
          addToCart(ID, 1, btn);
        }
      });
    });
    
    gridFiltersToggleOnOverflow();
    let popupCloseBtn = document.querySelectorAll('.multi-popup-close');
    if(popupCloseBtn) {
      popupCloseBtn.forEach(element => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          let that = e.currentTarget;
          let featureWrapper = that.closest('.multi-variant-popup-wrapper');
          if (featureWrapper) {
            featureWrapper.classList.remove('open');
            setTimeout(() => {
              featureWrapper.classList.remove('active');
            }, 700);
            document.querySelector("html.js").style.removeProperty("overflow");
          }
        });
      });
    }

    var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
    // console.log("BEFORE_RENDER_INSTOCK", instockValue);
    if (instockValue) {
      if (instockValue[0] === "true") {
        // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
        var inputForInstock = document.querySelector('#wizzy-search-filters-inStock-input');
        var inputForInstockMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');
        if (inputForInstock) {
          inputForInstock.setAttribute("checked", ""); 
        }
        if (inputForInstockMobile) {
          inputForInstockMobile.setAttribute("checked", ""); 
        }
      }
    }
    updateBodyClassForAppliedFilters();
    const filterCloseButton = document.querySelector(".wizzy-filters-close-button");
    const applyAllButton = document.querySelector(".wizzy-apply-all-button");
    if(filterCloseButton && applyAllButton) {
      filterCloseButton.addEventListener("click", closeFilterForMobile);
      applyAllButton.addEventListener("click", closeFilterForMobile);      
    }
    // window.history.scrollRestoration = "manual";
    // window.scrollTo(0, 0);  
    return data;
  });
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(data) {
      var inStockBtn = document.querySelector('#wizzy-search-filters-inStock-input');

      if (inStockBtn) {
        // inStockBtn.addEventListener('click', handleButtonClickForInstock);
        inStockBtn.addEventListener('click', handleButtonClickForInstock);
      }
        document.querySelectorAll(".product-card--add-to-cart-button-simple").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Prevent double clicks
        if (btn.classList.contains('loading')) return;

        const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

        btn.classList.add('loading');

        if (btn.classList.contains('disabled')) return;

        if (isPopupTrigger) {
          const productUrl = btn.dataset.vid;
          if (productUrl) {
            const url = `/products/${productUrl}?section_id=quick-add-product`;
            fetchProductDetails(url, btn, e);
          }
        } else {
          const ID = btn.getAttribute("data-product-id");
          addToCart(ID, 1, btn);
        }
      });
    });
    gridFiltersToggleOnOverflow();
    let popupCloseBtn = document.querySelectorAll('.multi-popup-close');
    if(popupCloseBtn) {
      popupCloseBtn.forEach(element => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          let that = e.currentTarget;
          let featureWrapper = that.closest('.multi-variant-popup-wrapper');
          if (featureWrapper) {
            featureWrapper.classList.remove('open');
            setTimeout(() => {
              featureWrapper.classList.remove('active');
            }, 700);
            document.querySelector("html.js").style.removeProperty("overflow");
          }
        });
      });
    }
    var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
    // console.log("BEFORE_RENDER_INSTOCK", instockValue);
    if (instockValue) {
      if (instockValue[0] === "true") {
        // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
        var inputForInstock = document.querySelector('#wizzy-search-filters-inStock-input');
        var inputForInstockMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');
        if (inputForInstock) {
          inputForInstock.setAttribute("checked", ""); 
        }
        if (inputForInstockMobile) {
          inputForInstockMobile.setAttribute("checked", ""); 
        }
      }
    }
    // window.history.scrollRestoration = "manual";
    // window.scrollTo(0, 0);
    updateBodyClassForAppliedFilters();
    const filterCloseButton = document.querySelector(".wizzy-filters-close-button");
    const applyAllButton = document.querySelector(".wizzy-apply-all-button");
    if(filterCloseButton && applyAllButton) {
      filterCloseButton.addEventListener("click", closeFilterForMobile);
      applyAllButton.addEventListener("click", closeFilterForMobile);      
    }
    return data;
  });
     
     
}



function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}
const targetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.remove('wizzy-autocomplete-open');
  }
}

document.addEventListener("DOMContentLoaded", function() {
    const closeButtonSearchDrawer = document.querySelector("#Search-Drawer .side-panel-close");
    if (closeButtonSearchDrawer) {
        closeButtonSearchDrawer.addEventListener("click", function() {
            document.documentElement.classList.remove("open-cc");
        });
    }
});


const wizzy_observer_config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break; // One update is enough per mutation batch
  }
};

const observer = new MutationObserver(callback);
if (targetNode) {
  observer.observe(targetNode, wizzy_observer_config);
  updateBodyClass();
}